// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Note Form Component */
note-form {
  display: block;
  width: 100%;
}

.note-form-container {
  padding: 1.5rem;
  width: 100%;
  overflow: hidden;
}

.note-form-container form {
  width: 100%;
}

.note-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.note-form-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.note-form-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.note-form-close-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.dark .note-form-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.note-form-group {
  margin-bottom: 1.25rem;
  width: 100%;
}

.note-form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.note-form-input,
.note-form-textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--input-border);
  border-radius: var(--radius-lg);
  font-size: 1rem;
  font-family: inherit;
  background-color: var(--bg-main);
  color: var(--text-primary);
  transition: all var(--transition-normal);
  box-sizing: border-box;
}

.dark .note-form-input,
.dark .note-form-textarea {
  border-color: var(--input-border);
}

.note-form-input:focus,
.note-form-textarea:focus {
  outline: none;
  border-color: var(--text-muted);
}

.note-form-input.invalid,
.note-form-textarea.invalid {
  border-color: var(--color-error);
}

.note-form-input.valid,
.note-form-textarea.valid {
  border-color: var(--color-success);
}

.note-form-textarea {
  min-height: 150px;
  resize: vertical;
  max-width: 100%;
}

.note-form-validation {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: var(--color-error);
  min-height: 1rem;
}

.note-form-char-count {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--text-muted);
  text-align: right;
}

.note-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.note-form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all var(--transition-normal);
}

.note-form-btn-secondary {
  background-color: transparent;
  color: var(--text-muted);
  border: 2px solid var(--text-muted);
}

.note-form-btn-secondary:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dark .note-form-btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.note-form-btn-primary {
  background-color: var(--text-muted);
  color: white;
}

.dark .note-form-btn-primary {
  color: var(--bg-main);
}

.note-form-btn-primary:hover:not(:disabled) {
  opacity: 0.9;
}

.note-form-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/note-form.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,0BAA0B;EAC1B,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Note Form Component */\nnote-form {\n  display: block;\n  width: 100%;\n}\n\n.note-form-container {\n  padding: 1.5rem;\n  width: 100%;\n  overflow: hidden;\n}\n\n.note-form-container form {\n  width: 100%;\n}\n\n.note-form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.note-form-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.note-form-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.note-form-close-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.dark .note-form-close-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.note-form-group {\n  margin-bottom: 1.25rem;\n  width: 100%;\n}\n\n.note-form-group label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.note-form-input,\n.note-form-textarea {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--input-border);\n  border-radius: var(--radius-lg);\n  font-size: 1rem;\n  font-family: inherit;\n  background-color: var(--bg-main);\n  color: var(--text-primary);\n  transition: all var(--transition-normal);\n  box-sizing: border-box;\n}\n\n.dark .note-form-input,\n.dark .note-form-textarea {\n  border-color: var(--input-border);\n}\n\n.note-form-input:focus,\n.note-form-textarea:focus {\n  outline: none;\n  border-color: var(--text-muted);\n}\n\n.note-form-input.invalid,\n.note-form-textarea.invalid {\n  border-color: var(--color-error);\n}\n\n.note-form-input.valid,\n.note-form-textarea.valid {\n  border-color: var(--color-success);\n}\n\n.note-form-textarea {\n  min-height: 150px;\n  resize: vertical;\n  max-width: 100%;\n}\n\n.note-form-validation {\n  display: block;\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--color-error);\n  min-height: 1rem;\n}\n\n.note-form-char-count {\n  display: block;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-align: right;\n}\n\n.note-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1.5rem;\n}\n\n.note-form-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.note-form-btn-secondary {\n  background-color: transparent;\n  color: var(--text-muted);\n  border: 2px solid var(--text-muted);\n}\n\n.note-form-btn-secondary:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.dark .note-form-btn-secondary:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.note-form-btn-primary {\n  background-color: var(--text-muted);\n  color: white;\n}\n\n.dark .note-form-btn-primary {\n  color: var(--bg-main);\n}\n\n.note-form-btn-primary:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.note-form-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
